module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required-field-field",
    class: {
      'has-error': _vm.errors.first('tipo de pessoa')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "tipo de pessoa"
    }
  }, [_vm._v("Tipo de pessoa:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 "
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.tipoFornecedor),
      expression: "nota.tipoFornecedor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "tipo de pessoa",
      "name": "tipo de pessoa"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.nota, "tipoFornecedor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.bloqueiaCampos = 0, _vm.nota.nomeFornecedor = '', _vm.nota.cepFornecedor = '', _vm.nota.enderecoFornecedor = ''
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Pessoa Física"
    }
  }, [_vm._v("Pessoa Física")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Pessoa Jurídica"
    }
  }, [_vm._v("Pessoa Jurídica")])])]), _vm._v(" "), (_vm.errors.first('tipo de pessoa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de pessoa')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('nome')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 "
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.nomeFornecedor),
      expression: "nota.nomeFornecedor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "nome",
      "disabled": _vm.bloqueiaCampos === 1,
      "name": "nome",
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.nota.nomeFornecedor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "nomeFornecedor", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('nome')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('nome')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field row",
    class: {
      'has-error': _vm.errors.first('cep')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cep"
    }
  }, [_vm._v("CEP:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 "
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cep",
      "name": "cep",
      "mask": ['#####-###'],
      "disabled": _vm.bloqueiaCampos === 1
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.loadCityAndState($event)
      }
    },
    model: {
      value: (_vm.nota.cepFornecedor),
      callback: function($$v) {
        _vm.$set(_vm.nota, "cepFornecedor", $$v)
      },
      expression: "nota.cepFornecedor"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cep')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cep')))]) : _vm._e()]), _vm._v(" "), (_vm.nota.cepFornecedor) ? _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding": "7px"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.nota.cidadeFornecedor) + " " + _vm._s((_vm.nota.estadoFornecedor) ? '/ ' + _vm.nota.estadoFornecedor : '') + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.nota.tipoFornecedor === 'Pessoa Jurídica') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpj')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cnpj"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|cnpj'),
      expression: "'required|cnpj'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cnpj",
      "disabled": _vm.bloqueiaCampos === 1,
      "name": "cnpj",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens,
      "type": "text"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurCpfCnpj(_vm.nota.cnpjFornecedor)
      }
    },
    model: {
      value: (_vm.nota.cnpjFornecedor),
      callback: function($$v) {
        _vm.$set(_vm.nota, "cnpjFornecedor", $$v)
      },
      expression: "nota.cnpjFornecedor"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.nota.tipoFornecedor === 'Pessoa Física') ? _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 "
  }, [_c('div', [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "cpf",
      "name": "cpf",
      "disabled": _vm.bloqueiaCampos === 1,
      "mask": ['###.###.###-##'],
      "type": "text"
    },
    nativeOn: {
      "blur": function($event) {
        return _vm.onBlurCpfCnpj(_vm.nota.cpfFornecedor)
      }
    },
    model: {
      value: (_vm.nota.cpfFornecedor),
      callback: function($$v) {
        _vm.$set(_vm.nota, "cpfFornecedor", $$v)
      },
      expression: "nota.cpfFornecedor"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('cpf')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cpf')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('endereço')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "endereço"
    }
  }, [_vm._v("Endereço:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 "
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nota.enderecoFornecedor),
      expression: "nota.enderecoFornecedor"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endereço",
      "disabled": _vm.bloqueiaCampos === 1,
      "name": "endereço",
      "type": "text"
    },
    domProps: {
      "value": (_vm.nota.enderecoFornecedor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.nota, "enderecoFornecedor", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('endereço ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('endereço')))]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Fornecedor")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51fc218a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/fornecedor.vue
// module id = 1952
// module chunks = 1